import { render, staticRenderFns } from "./editIndex.vue?vue&type=template&id=833386c2&scoped=true"
import script from "./editIndex.vue?vue&type=script&lang=js"
export * from "./editIndex.vue?vue&type=script&lang=js"
import style0 from "./editIndex.vue?vue&type=style&index=0&id=833386c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833386c2",
  null
  
)

export default component.exports